import { useEffect, useState } from 'react';

/**
 * Whether `element` scrolls sideways: its content is wider than its box (TMMAPP-0097 B14). A
 * scroll container needs a name and a tab stop only while it scrolls; otherwise it is plain
 * layout. Re-measured whenever the box or its first child resizes.
 */
export function useScrollsX(element: HTMLElement | null): boolean {
  const [scrolls, setScrolls] = useState(false);
  useEffect(() => {
    if (element === null || typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(() => {
      setScrolls(element.scrollWidth > element.clientWidth);
    });
    observer.observe(element);
    if (element.firstElementChild !== null) observer.observe(element.firstElementChild);
    return () => observer.disconnect();
  }, [element]);
  return scrolls;
}
